
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/press-room",
      function () {
        return require("private-next-pages/india/press-room.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/press-room"])
      });
    }
  